import { defineMessages } from 'react-intl'

const formattedMessage = {}

export const messages = defineMessages({
  welcomeMessage: {
    id: 't.app.dashboard.welcomeMessage',
    defaultMessage: 'XPay | Backoffice'
  },
  payments: {
    id: 't.app.dashboard.payments',
    defaultMessage: 'Payments'
  },
  configuration: {
    id: 't.app.dashboard.configuration',
    defaultMessage: 'Configuration'
  },
  services: {
    id: 't.app.dashboard.services',
    defaultMessage: 'Services'
  },
  customers: {
    id: 't.app.dashboard.customers',
    defaultMessage: 'Customers'
  },
  customersDescription: {
    id: 't.app.dashboard.customersDescription',
    defaultMessage: 'Add and manage customer contacts.'
  },
  actionManagement: {
    id: 't.app.dashboard.actionManagement',
    defaultMessage: 'MANAGE'
  },
  orders: {
    id: 't.app.dashboard.orders',
    defaultMessage: 'Orders'
  },
  ordersDescription: {
    id: 't.app.dashboard.ordersDescription',
    defaultMessage: 'Search and manage payment orders.'
  },
  operations: {
    id: 't.app.dashboard.operations',
    defaultMessage: 'Operations'
  },
  operationsDescription: {
    id: 't.app.dashboard.operationsDescription',
    defaultMessage: 'Search and manage payment operations.'
  },
  subscriptions: {
    id: 't.app.dashboard.subscriptions',
    defaultMessage: 'Subscriptions'
  },
  subscriptionsDescription: {
    id: 't.app.dashboard.subscriptionsDescription',
    defaultMessage: 'Search and manage subscriptions.'
  },
  terminalsManagment: {
    id: 't.app.dashboard.terminalManagement',
    defaultMessage: 'Terminals Management'
  },
  terminalsManagementDescription: {
    id: 't.app.dashboard.terminalManagementDescription',
    defaultMessage: 'Terminals management and configuration.'
  },
  users: {
    id: 't.app.header.users',
    defaultMessage: 'Users'
  },
  storeManagement: {
    id: 't.app.dashboard.storeManagement',
    defaultMessage: 'Stores management'
  },
  storeManagementDescription: {
    id: 't.app.dashboard.storeManagementDescription',
    defaultMessage: 'Stores management and configuration.'
  },

  quickActions: {
    id: 't.app.dashboard.quickActions',
    defaultMessage: 'Quick actions'
  },
  payByLink: {
    id: 't.app.dashboard.quickActions.payByLink',
    defaultMessage: 'New Pay-by-link Plus'
  },
  payToCard: {
    id: 't.app.header.quickActions.payToCard',
    defaultMessage: 'New Pay-to-card'
  },
  cardCheck: {
    id: 't.app.dashboard.quickActions.cardCheck',
    defaultMessage: 'Card check'
  },
  payByLinkManagement: {
    id: 't.app.header.services.payByLink',
    defaultMessage: 'Pay-by-Link Plus'
  },
  moto: {
    id: 't.app.dashboard.quickActions.motoPayment',
    defaultMessage: 'MOTO Payment'
  },
  dashboardPageTitle: {
    id: 't.app.dashboard.page.title',
    defaultMessage: 'XPay | Backoffice'
  },
  booking: {
    id: 't.app.header.quickActions.newBooking',
    defaultMessage: 'New Booking'
  },
  usersManagement: {
    id: 't.app.header.usersManagement',
    defaultMessage: 'Users management'
  },
  usersManagementDescription: {
    id: 't.app.dashboard.usersManagementDescription',
    defaultMessage: 'Users management and configuration.'
  },
  pblServices: {
    id: 't.app.dashboard.pblServices',
    defaultMessage: 'Pay-by-Link Plus.'
  },
  pblServicesDescription: {
    id: 't.app.dashboard.pblServicesDescription',
    defaultMessage: 'Pay-by-link Plus management'
  },
  bookingManagementService:{
    id: 't.app.dashboard.bookingManagementService',
    defaultMessage: 'Booking Management'
  },
  bookingManagementServiceDescription:{
    id: 't.app.dashboard.bookingManagementServiceDescription',
    defaultMessage: 'Booking management and operations'
  }

})

export default formattedMessage
